// The e-way bill part of a sales invoice entry: pure helpers (the screen is EWay.tsx).
import type { EwayCheck, EwayEntry, EwayTransport } from "../lib/api";

export const blankTransport = (): EwayTransport => ({ mode: 1, distance_km: null, vehicle_no: "", vehicle_type: "R", transporter_gstin: "", transporter_name: "" });
export const validDays = (km: number | null | undefined, odc = false) => Math.max(1, Math.ceil((km ?? 0) / (odc ? 20 : 200)));
export function needsAnswer(c: EwayCheck | null | undefined) { return !!c && (c.status === "required" || c.status === "check"); }

// before posting: what's missing in the answer, if anything
export function ewayProblem(check: EwayCheck | null | undefined, v: EwayEntry | null | undefined): string | null {
  if (needsAnswer(check) && !v) return "This invoice needs an e-way bill: say how below (make it here, the number you have, later, or why it isn't needed).";
  if (!v) return null;
  if (v.choice === "have" && !/^\d{12}$/.test(v.number ?? "")) return "The e-way bill number is 12 digits.";
  if (v.choice === "not_needed" && !(v.reason ?? "").trim()) return "Say why the e-way bill isn't needed.";
  if (v.choice === "generate") {
    const t = v.transport;
    if (!t || t.distance_km == null) return "E-way bill: give the distance in km.";
    if (t.mode === 1 && !(t.vehicle_no ?? "").trim() && !(t.transporter_gstin ?? "").trim()) return "E-way bill: by road, give the vehicle number or the transporter ID.";
    if (t.mode !== 1 && !(t.doc_no ?? "").trim()) return "E-way bill: give the transport document number.";
  }
  return null;
}

// the entry's e-way bill part as the server takes it (blanks dropped)
export function cleanEway(v: EwayEntry | null | undefined): EwayEntry | null {
  if (!v) return null;
  if (v.choice === "have") return { choice: "have", number: v.number || null, valid_upto: v.valid_upto ? new Date(v.valid_upto).toISOString() : null };
  if (v.choice === "not_needed") return { choice: "not_needed", reason: v.reason?.trim() || null };
  if (v.choice === "later") return { choice: "later" };
  const t = v.transport ?? blankTransport();
  const s = (x: string | null | undefined) => (x ?? "").trim() || null;
  return { choice: "generate", transport: { mode: t.mode, distance_km: t.distance_km, vehicle_no: t.mode === 1 ? s(t.vehicle_no) : null, vehicle_type: t.vehicle_type ?? "R",
    transporter_gstin: s(t.transporter_gstin), transporter_name: s(t.transporter_name), doc_no: t.mode === 1 ? null : s(t.doc_no), doc_date: t.mode === 1 ? null : s(t.doc_date),
    ship_to_state: s(t.ship_to_state), ship_to_place: s(t.ship_to_place), ship_to_pincode: s(t.ship_to_pincode) } };
}
